import React, { createContext } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Navbar from "components/Layouts/NavbarWrapper/Navbar";
import MaintenanceBanner from "components/Layouts/MaintenanceBanner/MaintenanceBanner";
import { MaintenanceBannerProvider } from "contexts/MaintenanceBannerContext";
import WhatsNewModal from "components/ProductUpdates/WhatsNewModal";
import { connect } from "react-redux";
import { loginWithSiteAppId } from "../../../redux/common/actions";
import { logOutUser } from "../../../redux/auth/actions";
import { authSlice } from "../../../redux/auth/reducers";
import roles from "helpers/roles";
const theme = createTheme();

export const NavbarStateContext = createContext({});

function NavbarWrapper({
	isApplicationPortal,
	children,
	userLogOut,
	loading,
	loginSiteApp,
	setUserDetail,
	userDetail,
}) {
	const siteAppId = localStorage.getItem("siteAppId");

	const me =
		JSON.parse(sessionStorage.getItem("me")) ||
		JSON.parse(localStorage.getItem("me"));

	const [navDrawerState, setNavDrawerState] = React.useState(false);

	// Release notes / What's New are a site-application feature for end users, not
	// the EMI admin area (portal, client/site management, settings, etc.). Only show
	// the modal when the user is actually inside a site application - the same
	// "site context" signal the nav uses for its site-app-only badges.
	const currentUser =
		userDetail && Object.values(userDetail).length > 0 ? userDetail : me || {};
	const showWhatsNew = !isApplicationPortal && Boolean(currentUser.siteAppID);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<MaintenanceBannerProvider>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					minHeight: "100vh",
				}}
			>
				<MaintenanceBanner />
				{showWhatsNew && <WhatsNewModal />}
				<div
					style={{
						display: "flex",
						backgroundColor: "#FAFAFA",
						flexGrow: 1,
					}}
				>
						<Navbar
							isApplicationPortal={isApplicationPortal}
							isLoading={loading}
							userLogOut={userLogOut}
							userDetail={userDetail}
							setUserDetail={setUserDetail}
							setNavState={setNavDrawerState}
						/>
						{(!siteAppId || me?.role === roles.clientAdmin) && (
							<NavbarStateContext.Provider value={{ navBarState: navDrawerState }}>
								<main
									style={{
										flexGrow: 1,
										padding: theme.spacing(3),
										overflowX: "hidden",
									}}
									id="main"
								>
									{children}
								</main>
							</NavbarStateContext.Provider>
						)}
					</div>
				</div>
			</MaintenanceBannerProvider>
		</ThemeProvider>
	);
}

const mapStateToProps = (state) => ({
	loading: state.commonData.loading,
	userDetail: state.authData.userDetail,
});

const mapDispatchToProps = (dispatch) => ({
	userLogOut: () => dispatch(logOutUser()),
	loginSiteApp: (id) => dispatch(loginWithSiteAppId(id)),
	setUserDetail: (data) => dispatch(authSlice.actions.dataSuccess({ data })),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavbarWrapper);
